import type { EdgeId } from '@ipfabric/utils';
import { unhighlightEdge } from 'components/Graph/commands/edges/unhighlightEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { getNodeHighlightedEdges } from './pathLookup/helpers/getNodeHighlightedEdges';

export const edgeMouseOut: GraphCommandFactory<EdgeId> =
  (cmdContext, dispatch) => (edgeId) => {
    const { activeNodeSn, highlightedEdges } =
      cmdContext.getState().pathlookup.pathInspector;
    const nodeHighlightedEdges = getNodeHighlightedEdges(
      activeNodeSn,
      highlightedEdges,
    );
    if (nodeHighlightedEdges === undefined) {
      return;
    }

    const isEdgeHighlighted =
      nodeHighlightedEdges.incomingEdges.includes(edgeId) ||
      nodeHighlightedEdges.outgoingEdges.includes(edgeId);
    // Unhighlight path inspector highlighted edge thickness
    if (isEdgeHighlighted) {
      dispatch(unhighlightEdge, {
        edgeId,
        thickness: true,
      });
    }
  };
